import React from "react";
import AutoSizer from "react-virtualized-auto-sizer";
import { getTime } from "date-fns";
import { useTheme } from "@mui/material";
import { SimpleLineChart } from "../highcharts/SimpleLineChart/SimpleLineChart";

export interface AccountPreviewChartData {
  value: number;
  date: Date;
}

export interface AccountPreviewChartProps {
  chartData: AccountPreviewChartData[];
  isFetching: boolean;
  height?: number;
  strokeColor?: string;
}

export const AccountPreviewChart = ({
  chartData,
  strokeColor,
  isFetching,
  height = 48,
}: AccountPreviewChartProps) => {
  const theme = useTheme();
  const chartDataFormatted = chartData.map(
    ({ value, date }) => [getTime(date), value] as [number, number]
  );

  return (
    <AutoSizer>
      {({ width }) => (
        <SimpleLineChart
          chartData={chartDataFormatted}
          lineColor={strokeColor || theme.palette.graphVisual["02"].mid}
          isLoading={isFetching}
          width={width}
          height={height}
        />
      )}
    </AutoSizer>
  );
};
